/**
 * Created by glenn on 3/15/2017.
 */

import React = require('react')
import ReactDOM = require('react-dom');
import {Provider} from 'react-redux';
import {quickMap} from 'webmapsjs/dist/olHelpers/quickMap';
import {LayerBaseVectorGeoJson} from 'webmapsjs/dist/layers/LayerBaseVectorGeoJson';
import {proj3857, proj4326} from 'webmapsjs/dist/olHelpers/projections';
import {makeBlueGreenRedGradient} from 'webmapsjs/dist/util/colors';
import {mapPopup} from 'webmapsjs/dist/olHelpers/mapPopup';
import {Legend} from './Legend';
import {Combo} from './combo';
import * as store from './store';
import * as styleAndPopup from './styleAndPopup';
import $ = require('jquery');
import {iStyleFunc} from "webmapsjs/dist/olHelpers/esriToOlStyle";

// alert('here');
let map;

let zerotohundred = makeBlueGreenRedGradient(0, 100, false);
let zerototenthousand = makeBlueGreenRedGradient(0, 10000, false);


let descrip = <div style={{textAlign: 'justify'}}>
    <h3 style={{margin: "2px 0 7px 0"}}>T3E Interactive Online Map</h3>
    Data on this map are aggregated from historical travel time technologies for
    the months of May and July 2015 and 2016. <br/><br/>Observation counts are in units of observations per hour on an
    average segment of the route. Only full routes are shown. For more information, refer to the T3E project:
    <ul style={{listStyle: 'none', paddingLeft: '7px', margin: '7px 0'}}>
        <li><a href="http://www.topslab.wisc.edu/tsmo/t3e/T3E_Analysis_Plan_v7-final.pdf" target="_blank">Analysis
            Plan</a></li>
        <li>--or--</li>
        <li><a href="http://www.topslab.wisc.edu/tsmo/t3e/T3E_Final_Report.pdf" target="_blank">Final Report</a></li>
    </ul>
</div>;

let layer = undefined;


class MapDiv extends React.Component<{}, {}> {

    componentDidMount() {
        map = quickMap({divId: 'map', center: {x: -9940377.376736274, y: 5280961.399498585}, zoom: 10});


        layer = new LayerBaseVectorGeoJson('', {
            transform: {dataProjection: proj3857, featureProjection: proj3857},
            style: styleAndPopup.style as iStyleFunc,
            name: "Segments"
        });

        let static_root = (document.getElementById('static-root') as HTMLInputElement).value;

        // console.log(static_root);

        $.get(`${static_root}/json/t3e.geojson`, {}, (d) => {
            layer.addFeatures(d);
        }, 'json');

        $.get(`${static_root}/json/t3e_data.json`, {}, (d) => {
            store.store.dispatch({type: store.ACTION_SET_DATA, data: d});
        }, 'json');


        mapPopup.addVectorPopup(layer, styleAndPopup.popupFunc);

        map.addLayer(layer.olLayer);

        window['map'] = map;
    }


    render() {
        return (
            <div id="app">
                <div id="map">
                    <div id="control">
                        {descrip}
                        <div id="control-container">
                            <Combo opts={store.years} label={store.ACTION_CHANGE_YEAR}/>
                            <Combo opts={store.dataTypes} label={store.ACTION_CHANGE_DATA_TYPE}/>
                            <Combo opts={store.timePeriods} label={store.ACTION_CHANGE_TIME_PERIOD}/>
                            <Combo opts={store.displayMethods} label={store.ACTION_CHANGE_DISPLAY_METHOD}/>
                        </div>
                        <Legend/>
                    </div>
                </div>
            </div>
        );
    }
}


ReactDOM.render(<Provider store={store.store}><MapDiv/></Provider>, document.getElementById('container'));


store.store.subscribe(() => {
    console.log(store.store.getState());
    if (layer) {
        layer.refresh();
    }
    mapPopup.closePopup()
});









